export const environment = {
  production: true,
  apiUrl:
    "https://as-test-smart-pd-integration-f7f4d4e2gya2fqg3.westeurope-01.azurewebsites.net/api",
  msalConfig: {
    auth: {
      clientId: "e6a825f4-66f4-4d75-b73e-2d51d09c11d8",
      authority:
        "https://login.microsoftonline.com/76e3e3ff-fce0-45ec-a946-bc44d69a9b7e",
      redirectUri: "/",
    },
  },
  resourceConfig: [
    {
      scopes: ["user.read"],
      uri: "https://graph.microsoft.com/v1.0/me",
    },
    {
      scopes: ["api://SMART-PD-TEST/User.Read"],
      uri: "https://as-test-smart-pd-integration-f7f4d4e2gya2fqg3.westeurope-01.azurewebsites.net/api",
    },
  ],
};
